/* eslint-disable no-control-regex */
import { escapeRegExp } from "./_helpers";

export const EMAIL_LENGTH = 100;
export const EMAIL_ACCOUNT_LENGTH = 64;

export const EMAIL_PATTERN = /^[0-9_A-Za-z](?:\.?[-+_'0-9A-Za-z])*@(?:[a-zA-Z0-9]{1,2}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9])(?:\.(?:[a-zA-Z0-9]{1,2}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]))*\.[a-zA-Z]{2,}$/;
export const SIMPLE_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const required = value =>
	value != null && (typeof value !== "string" || value.trim() !== "");

const isAccount = account =>
	account.length <= 64 &&
	/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")$/i.test(
		account,
	);

export const isDomainOrIp = domain =>
	/^(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i.test(
		domain,
	);

export const isIP = ip =>
	/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(
		ip,
	);

// eslint-disable-next-line no-unused-vars
const validateEmailParts = parts => {
	const [account, domain] = parts;
	return (
		parts.length === 2 &&
		Boolean(account) &&
		Boolean(domain) &&
		isAccount(account) &&
		isDomainOrIp(domain)
	);
};

const validateEmail = (regexRule, value) => {
	const parts = value.split("@");
	const [account, domain] = parts;
	return (
		parts.length === 2 &&
		Boolean(account) &&
		Boolean(domain) &&
		value.length <= EMAIL_LENGTH &&
		account.length <= EMAIL_ACCOUNT_LENGTH &&
		regexRule.test(value)
	);
};

export const isEmail = value => {
	return validateEmail(EMAIL_PATTERN, value);
};

export const isSimpleEmail = value => {
	return validateEmail(SIMPLE_EMAIL_PATTERN, value);
};

export const isCorrectEmailLen = len => value => {
	const parts = value.split("@");
	// Validator responcibility is to check local-part length
	// and it takes place only if email composed correctly "localPart@domainName.zone"
	return parts.length === 2 ? parts[0].length <= len : true;
};

export const minLen = len => value => value.length >= len;

export const maxLen = len => value => value.length <= len;

export const match = re => value => re.test(value);

export const endsWith = tail => match(new RegExp(`${escapeRegExp(tail)}$`));

export const startsWith = head => match(new RegExp(`^${escapeRegExp(head)}`));

export const min = minValue => value => value >= minValue;

export const greater = minValue => value => value > minValue;

export const max = maxValue => value => value <= maxValue;

export const less = maxValue => value => value < maxValue;

export const isTheSame = otherFieldName => (value, form) => value === form[otherFieldName];

export const notEqualTo = (text, caseSensitive = false) => value =>
	caseSensitive
		? value.toString() !== text.toString()
		: value.toString().toLowerCase() !== text.toString().toLowerCase();

export const isZipCode = (countryID, value) => {
	switch (countryID) {
		case 220:
			return /^[0-9]{5}(?:-[0-9]{4})?$/.test(value);
		case 38:
			return /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/.test(value);
		case 224:
			return /^[A-Z]{1,2}[0-9R][0-9A-Z]? [0-9][ABD-HJLNP-UW-Z]{2}$/.test(value);
		default:
			return true;
	}
};

export const oneOf = (list, ignoreCase = true) => {
	const expected = new Set(ignoreCase ? list.map(value => value.toUpperCase()) : list);
	return value => !value || expected.has(ignoreCase ? value.toUpperCase() : value);
};

export const notIn = (list, ignoreCase) => {
	const predicate = oneOf(list, ignoreCase);
	return value => !(value && predicate(value));
};

export const isUUID = value =>
	typeof value === "string" &&
	/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
